export const FETCH_STUDENT_COURSES_DURATION_DATA = 'FETCH_STUDENT_COURSES_DURATION_DATA';
